import { Injectable } from '@angular/core';
import { DottedKey } from '../../../../core/field-definitions/entities/field-definition.entity';
import { ExtendedProfileField } from '../../../../core/profiles/entities/extended-profile-field.entity';
import { ApiFragment } from '../../../../core/records/entities/api-fragment.class';
import { Cell } from '../../components/cells/_base/table-cell.entity';
import { TextCell } from '../../components/cells/text-cell/text-cell.entity';
import { ColumnWidth } from '../../entities/column-width.entity';
import { ProfileFieldColumnService } from '../base-columns/profile-field-column.service';

@Injectable({ providedIn: 'root' })
export class FileSizeColumnService extends ProfileFieldColumnService<ApiFragment> {
    protected readonly WIDTH: ColumnWidth = ColumnWidth.NORMAL;
    protected readonly DISABLE_SORT: boolean = false;

    protected getMapper(profileField: ExtendedProfileField): (item: ApiFragment) => Cell {
        return record => new TextCell(record.getHumanReadableFilesize());
    }

    protected getFieldSelectDottedKeys(profileField: ExtendedProfileField): DottedKey[] {
        return ['Technical.FileSize'] as DottedKey[];
    }
}
